<div class="fit-propercriteria-container" class="container-fluid" [formGroup]="formGroup">
    <div class="section-card">
        <p class="note">If the answer to any of the following questions is in the affirmative, please attach annexes and
            supporting documents,
            where appropriate, to provide all relevant details.<br>
            Please provide your replies in relation to the past 10 years.
        </p>
    </div>
    <div class="check-list">
        <ol class="custom-list">
            <span class="sub-header">A. Honesty, Integrity and Reputation</span>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>1. Have you been licensed, registered or approved under any law in any jurisdiction which
                            requires licensing, registration or approval in relation to any regulated activity? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_1')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_1')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_1')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_1')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_1"].invalid
                && (this.formGroup.controls["fitPropercriteria_1"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_1"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>2. Have you been refused the right or restricted in your right to carry on any trade,
                            business or
                            profession for which a specific licence, registration or other authorization is required by
                            law in
                            any jurisdiction?</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_2')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_2')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_2')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_2')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_2"].invalid
                && (this.formGroup.controls["fitPropercriteria_2"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_2"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>3. Have you been issued a prohibition order under any Act administered by Monetary
                            Authority
                            of Singapore or have you been prohibited from operating in any jurisdiction by any financial
                            services regulatory authority? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_3')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_3')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_3')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_3')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_3"].invalid
                && (this.formGroup.controls["fitPropercriteria_3"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_3"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>4. Have you been a shareholder of any corporation which holds membership of any class or
                            description of any operator of a market or clearing facility in any jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_4')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_4')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_4')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_4')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_4"].invalid
                && (this.formGroup.controls["fitPropercriteria_4"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_4"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>5. Have you been censured, disciplined, suspended or refused membership or registration by
                            Monetary Authority of Singapore, any other regulatory authority, an operator of a market or
                            clearing facility, any professional body or government agency, whether in Singapore or
                            elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_5')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_5')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_5')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_5')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_5"].invalid
                && (this.formGroup.controls["fitPropercriteria_5"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_5"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>6. Have you been the subject of any complaint made reasonably and in good faith, relating
                            to
                            activities that are regulated by Monetary Authority of Singapore or under any law in any
                            jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_6')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_6')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_6')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_6')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_6"].invalid
                && (this.formGroup.controls["fitPropercriteria_6"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_6"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>7. Have you ever been reported to the MAS pursuant to Financial Advisers Act (FAA) Notice
                            on
                            Reporting of Misconduct of Representatives by Financial Advisers, or equivalent provisions
                            under Securities & Futures Act (SFA), or any other Financial Services, Securities, Insurance
                            or Banking Regulations? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_7')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_7')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_7')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_7')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_7"].invalid
                && (this.formGroup.controls["fitPropercriteria_7"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_7"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>8. Have you been reported and/or issued Letter of Suspension/Warning/Advice by your past
                            employers due to any misconducts or offences?</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #fitPropercriteria_8 [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_8')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'fitPropercriteria_8',8)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_8')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'fitPropercriteria_8',8)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['fitPropercriteria_8'].value == true && fitPropercriteria_8.checked){
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                        <mat-label class="field-label">Attachment</mat-label>
                        <div class="upload-container">
                            <div class="upload-box">
                                <input type="file" id="attachment8" [disabled]="readonly()"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    (change)="onAttachmentFileChange($event,'attachment8','attachment8_file','fitPropercriteria_8')">
                                <input type="text" formControlName="attachment8" hidden>

                                <!-- Show filename OR placeholder -->
                                @if(!this.formGroup.get('attachment8')?.value){
                                <span>
                                    Choose a file
                                </span>
                                }
                                @if(this.formGroup.get('attachment8')?.value){
                                <div class="attachment-row">
                                    <span class="file-name">
                                        {{ formGroup.get('attachment8')?.value }}
                                    </span>
                                    @if(readonly() === false){
                                    <button mat-icon-button color="primary" class="delete-btn"
                                        (click)="removeFile('attachment8','attachment8_file','fitPropercriteria_8')">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    }
                                    <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="previewAttachment('attachment8','fitPropercriteria_8')">
                                    <mat-icon>visibility</mat-icon>
                                    </button>
                                </div>
                                }
                            </div>
                        </div>
                        @if(this.formGroup.controls["attachment8"]?.invalid
                        && (this.formGroup.controls["attachment8"].touched ||
                        this.formGroup.controls["attachment8"].dirty)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["attachment8"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }@else if(this.formGroup.controls["attachment8"].errors?.['invalidType']){
                            <span>Only PDF, JPG, PNG files are allowed.</span>
                            }
                            @else if(this.formGroup.controls["attachment8"].errors?.['maxSize']){
                            <span>File size must be less than or equal to 5MB.</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["fitPropercriteria_8"].invalid
                && (this.formGroup.controls["fitPropercriteria_8"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_8"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>9. Have you been the subject of any proceedings of a disciplinary or criminal nature or
                            have you
                            been notified of any potential proceedings or of any investigation which might lead to those
                            proceedings, under any law in any jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_9')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_9')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_9')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_9')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_9"].invalid
                && (this.formGroup.controls["fitPropercriteria_9"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_9"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>10. Have you been convicted of any offence or are you being subject to any pending
                            proceedings
                            which may lead to such a conviction, under any law in any jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #fitPropercriteria_10 [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_10')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'fitPropercriteria_10',10)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_10')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'fitPropercriteria_10',10)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['fitPropercriteria_10'].value == true && fitPropercriteria_10.checked){
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                        <mat-label class="field-label">Attachment</mat-label>
                        <div class="upload-container">
                            <div class="upload-box">
                                <input type="file" id="attachment10" [disabled]="readonly()"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    (change)="onAttachmentFileChange($event,'attachment10','attachment10_file','fitPropercriteria_10')">
                                <input type="text" formControlName="attachment10" hidden>

                                <!-- Show filename OR placeholder -->
                                @if(!this.formGroup.get('attachment10')?.value){
                                <span>
                                    Choose a file
                                </span>
                                }
                                @if(this.formGroup.get('attachment10')?.value){
                                <div class="attachment-row">
                                    <span class="file-name">
                                        {{ this.formGroup.get('attachment10')?.value }}
                                    </span>
                                    @if(readonly() === false){
                                    <button mat-icon-button color="primary" class="delete-btn"
                                        (click)="removeFile('attachment10','attachment10_file','fitPropercriteria_10')">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    }
                                    <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="previewAttachment('attachment10','fitPropercriteria_10')">
                                    <mat-icon>visibility</mat-icon>
                                    </button>
                                </div>
                                }
                            </div>
                        </div>
                        @if(this.formGroup.controls["attachment10"]?.invalid
                        && (this.formGroup.controls["attachment10"].touched )
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["attachment10"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }
                            @else if(this.formGroup.controls["attachment10"].errors?.['invalidType']){
                            <span>Only PDF, JPG, PNG files are allowed.</span>
                            }
                            @else if(this.formGroup.controls["attachment10"].errors?.['maxSize']){
                            <span>File size must be less than or equal to 5MB.</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["fitPropercriteria_10"].invalid
                && (this.formGroup.controls["fitPropercriteria_10"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_10"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>11. Have you had any judgment (in particular,that associated with a finding of fraud,
                            misrepresentation or dishonesty) entered against you in any civil proceedings or a party to
                            any pending proceedings which may lead to such a judgment, under any law in any
                            jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_11')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_11')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_11')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_11')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_11"].invalid
                && (this.formGroup.controls["fitPropercriteria_11"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_11"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>12. Have you accepted civil liability for fraud, misrepresentation or dishonesty under any
                            law in
                            any jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_12')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_12')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_12')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_12')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_12"].invalid
                && (this.formGroup.controls["fitPropercriteria_12"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_12"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>13. Have you had any civil penalty enforcement action taken against you by Monetary
                            Authority
                            of Singapore or any other regulatory authority under any law in any jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_13')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_13')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_13')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_13')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_13"].invalid
                && (this.formGroup.controls["fitPropercriteria_13"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_13"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>14. Have you contravened or abetted another person in breach of any laws or regulations,
                            business rules or codes of conduct, whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_14')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_14')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_14')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_14')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_14"].invalid
                && (this.formGroup.controls["fitPropercriteria_14"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_14"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>15. Have you been the subject of any investigations or disciplinary proceedings or been
                            issued a
                            warning or reprimand by Monetary Authority of Singapore, any other regulatory authority, an
                            operator of a market or clearing facility, any professional body or government agency,
                            whether
                            in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_15')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_15')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_15')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_15')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_15"].invalid
                && (this.formGroup.controls["fitPropercriteria_15"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_15"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>16. Have you been refused a fidelity or surety bond, whether in Singapore or
                            elsewhere?</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_16')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_16')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_16')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_16')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_16"].invalid
                && (this.formGroup.controls["fitPropercriteria_16"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_16"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>17. Have you demonstrated an unwillingness to comply with any regulatory requirement or to
                            uphold any professional and ethical standards, whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_17')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_17')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_17')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_17')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_17"].invalid
                && (this.formGroup.controls["fitPropercriteria_17"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_17"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>18. Have you been untruthful or provided false or misleading information to Monetary
                            Authority of
                            Singapore or been uncooperative in any dealings with Monetary Authority of Singapore or any
                            other regulatory authority in any jurisdiction? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_18')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_18')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_18')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_18')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_18"].invalid
                && (this.formGroup.controls["fitPropercriteria_18"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_18"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>19. Are you or have you been a director, partner, substantial shareholder or concerned in
                            the
                            management of a business that has been censured, disciplined, prosecuted or convicted of a
                            criminal offence, or been the subject of any disciplinary or criminal investigation or
                            proceeding,
                            in Singapore or elsewhere, in relation to any matter that took place while you were a
                            director,
                            partner, substantial shareholder or concerned in the management of the business? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_19')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_19')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_19')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_19')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_19"].invalid
                && (this.formGroup.controls["fitPropercriteria_19"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_19"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>20. Are you or have you been a director, partner, substantial shareholder or concerned in
                            the
                            management of a business that has been suspended or refused membership or registration
                            by Monetary Authority of Singapore, any other regulatory authority, an operator of a market
                            or clearing facility, any professional body or government agency, whether in Singapore or
                            elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_20')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_20')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_20')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_20')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_20"].invalid
                && (this.formGroup.controls["fitPropercriteria_20"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_20"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>21. Have you been a director, partner, substantial shareholder or concerned in the
                            management
                            of a business that has gone into insolvency, liquidation or administration during the period
                            when, or within a period of one year after, you were a director, partner, substantial
                            shareholder
                            or concerned in the management of the business, whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_21')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_21')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_21')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_21')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_21"].invalid
                && (this.formGroup.controls["fitPropercriteria_21"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_21"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>22. Have you been dismissed or asked to resign from office, employment, a position of
                            trust
                            or a
                            fiduciary appointment or similar position, whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_22')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_22')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_22')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_22')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_22"].invalid
                && (this.formGroup.controls["fitPropercriteria_22"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_22"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>23. Are you or have you been subject to disciplinary proceedings by your current or former
                            employer(s), whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_23')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_23')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_23')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_23')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_23"].invalid
                && (this.formGroup.controls["fitPropercriteria_23"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_23"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>24. Have you been disqualified from acting as a director or disqualified from acting in
                            any
                            managerial capacity, whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_24')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_24')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_24')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_24')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_24"].invalid
                && (this.formGroup.controls["fitPropercriteria_24"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_24"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>25. Have you been an officer found liable for an offence committed by a body corporate as
                            a
                            result
                            of the offence having proved to have been committed with the consent or connivance of, or
                            neglect attributable to you, whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_25')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_25')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_25')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_25')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_25"].invalid
                && (this.formGroup.controls["fitPropercriteria_25"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_25"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>26. Are you carrying on business in, or are you acting as a representative in respect of,
                            providing
                            credit rating services, are you or have you been in observance of the Code of Conduct for
                            Credit Rating Agencies. </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_26')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_26')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_26')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_26')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_26"].invalid
                && (this.formGroup.controls["fitPropercriteria_26"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_26"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <span class="sub-header">B. Financial Soundness</span>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>27. Are you or have you been unable to fulfil any of your financial obligations, whether
                            in
                            Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #fitPropercriteria_27 [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_27')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'fitPropercriteria_27',27)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_27')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'fitPropercriteria_27',27)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['fitPropercriteria_27'].value == true && fitPropercriteria_27.checked){
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                        <mat-label class="field-label">Attachment</mat-label>
                        <div class="upload-container">
                            <div class="upload-box">
                                <input type="file" id="attachment27" [disabled]="readonly()"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    (change)="onAttachmentFileChange($event,'attachment27','attachment27_file','fitPropercriteria_27')">
                                <input type="text" formControlName="attachment27" hidden>
                                <!-- Show filename OR placeholder -->
                                @if(!this.formGroup.get('attachment27')?.value){
                                <span>
                                    Choose a file
                                </span>
                                }
                                @if(this.formGroup.get('attachment27')?.value){
                                <div class="attachment-row">
                                    <span class="file-name">
                                        {{ this.formGroup.get('attachment27')?.value }}
                                    </span>
                                    @if(readonly() === false){
                                    <button mat-icon-button color="primary" class="delete-btn"
                                        (click)="removeFile('attachment27','attachment27_file','fitPropercriteria_27')">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    }
                                    <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="previewAttachment('attachment27','fitPropercriteria_27')">
                                    <mat-icon>visibility</mat-icon>
                                    </button>
                                </div>
                                }
                            </div>
                        </div>
                        @if(this.formGroup.controls["attachment27"]?.invalid
                        && (this.formGroup.controls["attachment27"].touched ||
                        this.formGroup.controls["attachment27"].dirty)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["attachment27"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }@else if(this.formGroup.controls["attachment27"].errors?.['invalidType']){
                            <span>Only PDF, JPG, PNG files are allowed.</span>
                            }
                            @else if(this.formGroup.controls["attachment27"].errors?.['maxSize']){
                            <span>File size must be less than or equal to 5MB.</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["fitPropercriteria_27"].invalid
                && (this.formGroup.controls["fitPropercriteria_27"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_27"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>28. Have you been placed under the Debt Repayment Scheme (DRS), entered into a compromise
                            or scheme of arrangement with your creditors or made an assignment for the benefit of your
                            creditors, being a compromise, scheme of arrangement or assignment that is still in
                            operation,
                            whether in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #fitPropercriteria_28 [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_28')?.value === true"
                            (change)="onCheckboxChange1($event.checked, true,'fitPropercriteria_28',28)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_28')?.value === false"
                            (change)="onCheckboxChange1($event.checked, false,'fitPropercriteria_28',28)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['fitPropercriteria_28'].value == true && fitPropercriteria_28.checked){

                    <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                        <mat-label class="field-label">Attachment</mat-label>
                        <div class="upload-container">
                            <div class="upload-box">
                                <input type="file" id="attachment28" [disabled]="readonly()"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    (change)="onAttachmentFileChange($event,'attachment28','attachment28_file','fitPropercriteria_28')">
                                <input type="text" formControlName="attachment28" hidden>

                                <!-- Show filename OR placeholder -->
                                @if(!this.formGroup.get('attachment28')?.value){
                                <span>
                                    Choose a file
                                </span>
                                }
                                @if(this.formGroup.get('attachment28')?.value){
                                <div class="attachment-row">
                                    <span class="file-name">
                                        {{ this.formGroup.get('attachment28')?.value }}
                                    </span>
                                    @if(readonly() === false){
                                    <button mat-icon-button color="primary" class="delete-btn"
                                        (click)="removeFile('attachment28','attachment28_file','fitPropercriteria_28')">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    }
                                    <button mat-icon-button color="primary" class="delete-btn"
                                    (click)="previewAttachment('attachment28','fitPropercriteria_28')">
                                    <mat-icon>visibility</mat-icon>
                                    </button>
                                </div>
                                }
                            </div>
                        </div>
                        @if(this.formGroup.controls["attachment28"]?.invalid
                        && (this.formGroup.controls["attachment28"].touched ||
                        this.formGroup.controls["attachment28"].dirty)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["attachment28"].errors?.["required"]) {
                            <span>{{message}}</span>
                            }@else if(this.formGroup.controls["attachment28"].errors?.['invalidType']){
                            <span>Only PDF, JPG, PNG files are allowed.</span>
                            }
                            @else if(this.formGroup.controls["attachment28"].errors?.['maxSize']){
                            <span>File size must be less than or equal to 5MB.</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                </div>
                @if(this.formGroup.controls["fitPropercriteria_28"].invalid
                && (this.formGroup.controls["fitPropercriteria_28"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_28"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>29. Are you subject to a judgment debt which is unsatisfied, either in whole or in part,
                            whether in
                            Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_29')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_29')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_29')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_29')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_29"].invalid
                && (this.formGroup.controls["fitPropercriteria_29"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_29"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>30. Are you or have you been the subject of a bankruptcy petition, whether in Singapore or
                            elsewhere?</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_30')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_30')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_30')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_30')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_30"].invalid
                && (this.formGroup.controls["fitPropercriteria_30"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_30"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>31. Have you been adjudicated a bankrupt and the bankruptcy is undischarged, whether in
                            Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_31')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_31')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_31')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_31')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_31"].invalid
                && (this.formGroup.controls["fitPropercriteria_31"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_31"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>32. Are you or have you been subject to any other process outside Singapore that is
                            similar to
                            those referred to in Question 30 and 31?</span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_32')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_32')">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('fitPropercriteria_32')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_32')">
                            No
                        </mat-checkbox>
                    </div>
                </div>
                @if(this.formGroup.controls["fitPropercriteria_32"].invalid
                && (this.formGroup.controls["fitPropercriteria_32"].touched)
                ) {
                <mat-error>
                    @if(this.formGroup.controls["fitPropercriteria_32"].errors?.["required"]) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                </mat-error>
                }
            </li>
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <p>33. Have you been engaged in any activity, practice or conduct which would constitute tax
                            evasion or tax evasion facilitation offence*?<br>

                            *Tax evasion offence refers to any form of fraudulent conduct which seeks to divert money
                            from the public revenue, depriving it of money to which it is entitled. Tax evasion is
                            characterized by dishonesty on the part of
                            the taxpayer. That may be committed either by: <br>
            <li>- a positive act – such as submitting false
                or misleading information or the deliberate
                concealment of assets or income, or</li>
            <li>- by omission – such as failing to declare income on
                which tax is due, or failing to
                declare the sale of asset which would be subject to capital gains tax</li>

            Tax evasion facilitation offence is committed where you knowingly and dishonestly
            encourage or assist the commission of a tax evasion offence. That may be committed either
            by:
            <li>- a positive action,</li>
            <li>- failure to act when required to do so, or</li>
            <li>- by wilful blindness</li>
            </p>
    </div>
    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
        <mat-checkbox #fitPropercriteria_33 [disabled]="this.readonly()"
            [checked]="formGroup.get('fitPropercriteria_33')?.value === true"
            (change)="onCheckboxChange1($event.checked, true,'fitPropercriteria_33',33)">
            Yes
        </mat-checkbox>

        <mat-checkbox [disabled]="this.readonly()" [checked]="formGroup.get('fitPropercriteria_33')?.value === false"
            (change)="onCheckboxChange1($event.checked, false,'fitPropercriteria_33',33)">
            No
        </mat-checkbox>
    </div>
    @if(this.formGroup.controls['fitPropercriteria_33'].value == true && fitPropercriteria_33.checked){
    <div>
        <mat-label>If Yes, please specify:</mat-label>
        <input matInput formControlName="fitPropercriteriayes_33" type="text" />
        @if(this.formGroup.controls["fitPropercriteriayes_33"].invalid
        && (this.formGroup.controls["fitPropercriteriayes_33"].touched)
        ) {
        <mat-error>
            @if(this.formGroup.controls["fitPropercriteriayes_33"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
        </mat-error>
        }
    </div>
    }
</div>
@if(this.formGroup.controls["fitPropercriteria_33"].invalid
&& (this.formGroup.controls["fitPropercriteria_33"].touched)
) {
<mat-error>
    @if(this.formGroup.controls["fitPropercriteria_33"].errors?.["required"]) {
    <span>{{message}}</span>
    }
    @else {
    <span></span>
    }
</mat-error>
}
</li>
<span class="sub-header">Balanced Score Card (BSC) Grading</span>
<li>
    <div class="row">
        <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
            <span>34. Have you been accorded BSC Grade ‘E’ as a representative or “Unsatisfactory” as a
                supervisor? </span>
        </div>
        <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
            <mat-checkbox [disabled]="this.readonly()" [checked]="formGroup.get('fitPropercriteria_34')?.value === true"
                (change)="onCheckboxChange($event.checked, true,'fitPropercriteria_34')">
                Yes
            </mat-checkbox>

            <mat-checkbox [disabled]="this.readonly()"
                [checked]="formGroup.get('fitPropercriteria_34')?.value === false"
                (change)="onCheckboxChange($event.checked, false,'fitPropercriteria_34')">
                No
            </mat-checkbox>
        </div>
    </div>
    @if(this.formGroup.controls["fitPropercriteria_34"].invalid
    && (this.formGroup.controls["fitPropercriteria_34"].touched)
    ) {
    <mat-error>
        @if(this.formGroup.controls["fitPropercriteria_34"].errors?.["required"]) {
        <span>{{message}}</span>
        }
        @else {
        <span></span>
        }
    </mat-error>
    }
</li>
</ol>
<span>Please complete the tables below with the last 8 grades accorded to you. (Optional)</span>
<table class="custom-table">
    <!-- Row 1 -->
    <tr formArrayName="quarteryear_1">
        <!-- First column (Title column) -->
        <td><strong>Quarter / Year
            </strong><br>e.g. Q1’17</td>

        <!-- Next 8 columns with mat-form-field -->
        @for (col of quarteryear_1.controls; let i = $index; track i) {
        <td>
            <mat-form-field class="compact-field">
                <input matInput [formControlName]="i" />
            </mat-form-field>
        </td>
        }
    </tr>

    <!-- Row 2 -->
    <tr formArrayName="gradeRepresentative">
        <!-- First column (Title column) -->
        <td><strong>Grade as a
                representative </strong></td>

        <!-- Next 8 columns with mat-select -->
        @for (col of gradeRepresentative.controls; let i = $index; track i) {
        <td>
            <mat-form-field class="compact-field">

                <mat-select [formControlName]="i">
                    <mat-option value="A">A</mat-option>
                    <mat-option value="B">B</mat-option>
                    <mat-option value="C">C</mat-option>
                    <mat-option value="D">D</mat-option>
                    <mat-option value="E">E</mat-option>
                    <mat-option value="Ungraded">Ungraded</mat-option>
                </mat-select>
            </mat-form-field>
        </td>
        }
    </tr>
</table>
<br>
<table class="custom-table">
    <!-- Row 1 -->
    <tr formArrayName="quarteryear_2">
        <!-- First column (Title column) -->
        <td><strong>Quarter / Year
            </strong><br>e.g. Q1’17</td>

        <!-- Next 8 columns with mat-form-field -->
        @for (col of quarteryear_2.controls; let i = $index; track i) {
        <td>
            <mat-form-field class="compact-field">
                <input matInput [formControlName]="i" />
            </mat-form-field>
        </td>
        }
    </tr>

    <!-- Row 2 -->
    <tr formArrayName="gradeSupervisor">
        <!-- First column (Title column) -->
        <td><strong>Grade as a
                Supervisor</strong></td>

        <!-- Next 8 columns with mat-select -->
        @for (col of gradeSupervisor.controls; let i = $index; track i) {
        <td>
            <mat-form-field class="compact-field">
                <mat-select [formControlName]="i">
                    <mat-option value="Good"> Good</mat-option>
                    <mat-option value="Satisfactory"> Satisfactory</mat-option>
                    <mat-option value="Fair">Fair</mat-option>
                    <mat-option value="Unsatisfactory">Unsatisfactory</mat-option>
                </mat-select>
            </mat-form-field>
        </td>
        }
    </tr>
</table>

</div>
@if(readonly() === false){
@if(isVisible()===true){
<div class="editor-actions">
    <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
    <button type="button" class="save-btn" (click)="saveSection()" >
        <mat-icon>save</mat-icon>Save</button>
</div>

}@else{
<div class="form-actions">

    <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

        <span>Save & Continue</span>
        <mat-icon>arrow_forward</mat-icon>

    </button>

</div>
}
}


</div>